module.exports = __webpack_public_path__ + "media/images/procedure_managements/how_to_create/img_2-fb583d7a12b0640aadbf56ceadf6e934.png";